module.exports = __webpack_public_path__ + "img/01 - Condominio_das_Americas_SalaoFestas.21e4e03e.jpg";